module.exports = __webpack_public_path__ + "img/content-slide.ec2ba4eb.svg";